
























































































import { Vue, Component, Prop } from 'vue-property-decorator';
import getGameRecentArticles from '~/queries/gameNewsArticles.gql';
const _truncate = require('lodash.truncate');

@Component
export default class GameNewsArticles extends Vue {
  @Prop(String) gameName!: string;
  articleLimit = 4;
  articles: Array<{
    content: string;
    title: string;
    pubDate: string;
    thumbnail: string;
    link: string;
  }> = [];
  isLoading = true;

  created() {
    this.getGameArticles();
  }

  async getGameArticles() {
    try {
      const { data } = await this.$apollo.query({
        query: getGameRecentArticles,
        variables: {
          limit: this.articleLimit,
          authorTag: this.gameName,
        },
        fetchPolicy: 'cache-first',
      });
      if (data?.gameRecentArticles?.articles?.length) {
        this.articles = data.gameRecentArticles.articles;
      }
    } catch (err) {
      console.log('fetch news error: ' + err);
    }
    this.isLoading = false;
  }

  get newsIsVisible() {
    return this.isLoading || (!this.isLoading && this.articles.length);
  }

  get formattedArticles() {
    return this.articles.map(article => {
      const { title, pubDate, thumbnail, link, content } = article;

      const truncatedContent = _truncate(content, {
        length: this.calculateTruncateLength(article.title),
        separator: ' ',
      });

      return {
        content: truncatedContent,
        title,
        pubDate,
        thumbnail,
        link,
      };
    });
  }

  calculateTruncateLength(title: string) {
    const { lg, sm, xl, width } = this.$vuetify.breakpoint;
    let pLength = 18;
    let hLength = 18;
    let pLineBase = 4;
    let hLineBase = 3;

    if (sm) {
      pLength = 37;
      hLength = 28;
      pLineBase = 9;
      hLineBase = 2;
    } else if (xl) {
      pLength = 43;
      hLength = 36;
      pLineBase = 7;
      hLineBase = 2;
    } else if (width > 1564) {
      pLength = 37;
      hLength = 33;
      pLineBase = 7;
      hLineBase = 2;
    } else if (lg) {
      pLength = 29;
      hLength = 23;
      pLineBase = 5;
      hLineBase = 3;
    }
    const headingLinesCount = Math.ceil(title.length / hLength);
    const baseTruncLength = pLength * pLineBase;
    const linesToSubtract = headingLinesCount - hLineBase;

    return baseTruncLength - linesToSubtract * pLength;
  }
}
